export interface TagTypeOption {
  id: string;
  tag: string;
  instrumentType: string;
  modelTags: string;
  analysisTag: string;
}

export interface ProgramVersionTagOption {
  id: string;
  tag: string;
  programVersion: string;
}

export interface InstrumentTypeOption {
  id: string;
  tag: string;
  instrumentType: string;
}

export interface TagOptions {
  instrumentTypeOptions: InstrumentTypeOption[];
  modelTagOptions: TagTypeOption[];
  analysisTagOptions: TagTypeOption[];
  tagOptions: TagTypeOption[];
  allTagOptions: TagTypeOption[];
  programVersionOptions: ProgramVersionTagOption[];
}

export interface TagState {
  readonly instrumentTypeOptions: TagTypeOption[];
  readonly programVersionOptions: ProgramVersionTagOption[];
  readonly modelTagOptions: TagTypeOption[];
  readonly analysisTagOptions: TagTypeOption[];
  readonly allTagOptions: TagTypeOption[];
  readonly tagsLoading: boolean;
}

export const GET_TAG_OPTIONS = "GET_TAG_OPTIONS";
export const SET_TAG_OPTIONS = "SET_TAG_OPTIONS";
export const GET_TAG_LOADING = "GET_TAG_LOADING";
export const SET_TAG_LOADING = "SET_TAG_LOADING";

export interface SetTagOptionsAction {
  type: typeof SET_TAG_OPTIONS;
  payload: TagOptions;
}

export interface SetTagLoadingAction {
  type: typeof SET_TAG_LOADING;
  payload: boolean;
}

export type TagActionTypes = SetTagOptionsAction | SetTagLoadingAction;
